import { defineComponent, reactive } from 'vue'
import { MenuUnfoldOutlined, MenuFoldOutlined, QuestionCircleFilled } from '@ant-design/icons-vue'
import AvatarDropdown from './AvatarDropdown'
import request from '@/utils/request'
import { message } from 'ant-design-vue'
import Area from '../area'
import { useToggle } from '@vueuse/core'
import { json } from 'stream/consumers'

export default defineComponent({
  components: {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    'avatar-dropdown': AvatarDropdown
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    toggle: null
  },
  setup(props, { emit }) {
    const toggle = () => {
      emit('toggle')
    }

    const state = reactive({
      ClientIDList: [] as any[],
      SupplierIDList: [],
      EBKClientIDList: [] as any[],
      userID: ''
    })

    const getStrFromArr = (params: Array<any> | null) => {
      if (params) {
        return params.join(',') || 'No permission!'
      }

      return 'Unrestricted access!'
    }

    const goOld = () => {
      window.location.href = window.location.href.replace('a.didaadmin', 'a-webapi.didaadmin')
    }
    const [visibleModal, togglevisibleModal] = useToggle(false)

    const getPermissionList = (formState: any) => {
      request.post('api/Base/Analysis/GetPermission').then((t: any) => {
        if (t.State == 200) {
          state.ClientIDList = t.Data.ClientIDScope
          state.SupplierIDList = t.Data.SupplierIDScope
          state.EBKClientIDList = t.Data.EBKClientIDList
          state.userID = t.Data.userID
          togglevisibleModal(true)
        } else {
          message.error(t.Message)
        }
      })
    }

    return () => (
      <a-layout-header class="layout-header">
        <a-space>
          {props.collapsed ? (
            <menu-unfold-outlined class="trigger" onClick={toggle} />
          ) : (
            <menu-fold-outlined class="trigger" onClick={toggle} />
          )}

          <a-button onClick={getPermissionList}>
            My information
            <a-tooltip
              v-slots={{
                title: () => {
                  return (
                    <>
                      <span>获取可以查看的Client列表和Supplier列表以及UserID。</span>
                      <br />
                      <span>
                        Get me the customer and supplier lists I can access, along with the UserID
                      </span>
                    </>
                  )
                }
              }}
            >
              <QuestionCircleFilled />
            </a-tooltip>
          </a-button>

          <a href="https://didatravel.feishu.cn/docx/BloydiuWXohI1CxDQ50cyndqnYf" target="_blank">
            请求流程
          </a>
          <a href="https://didatravel.feishu.cn/docx/NsmAddplkozvzsxd8sbcK44EnSf" target="_blank">
            统计指标
          </a>
        </a-space>

        <a-space>
          <avatar-dropdown></avatar-dropdown>
        </a-space>

        <a-Modal
          visible={visibleModal.value}
          onOk={() => {
            togglevisibleModal(false)
          }}
          onCancel={() => togglevisibleModal(false)}
          bodyStyle={{ maxHeight: '600px', overflow: 'auto' }}
          width="50%"
        >
          <a-template>
            <a-collapse>
              <a-collapse-panel key="1" header="My UserID">
                <p>{state.userID}</p>
              </a-collapse-panel>
              <a-collapse-panel key="2" header="My ClientIDList">
                <p>{getStrFromArr(state.ClientIDList)}</p>
              </a-collapse-panel>
              <a-collapse-panel key="3" header="My SupplierIDList">
                <p>{getStrFromArr(state.SupplierIDList)}</p>
              </a-collapse-panel>
              <a-collapse-panel key="4" header="My EBKClientIDList">
                <p>{getStrFromArr(state.EBKClientIDList)}</p>
              </a-collapse-panel>
            </a-collapse>
          </a-template>
        </a-Modal>
      </a-layout-header>
    )
  }
})
